import { Input, InputNumber, DatePicker, Select, Radio, Checkbox, Upload } from "antd";
import { DomainFieldConfig, FieldType } from "../type";
import { DictData } from "./type";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;
const { TextArea } = Input;

// 根据字段类型渲染表单控件
export const renderFormItem = (item: any, disabled = false, flag = false) => {
    const fieldType = item.attr_zdlx || item.fieldType;
    const options = item.attr_nr || item?.content?.options;
    const label = item.dictName || item.fieldName;

    switch (fieldType) {
        case FieldType.SHORT_TEXT:
            return (
                <Input
                    placeholder={`请输入${label}`}
                    disabled={flag ? true : disabled}
                    maxLength={100}
                />
            );

        case FieldType.LONG_TEXT:
            return (
                <TextArea
                    placeholder={`请输入${label}`}
                    disabled={disabled}
                    maxLength={1000}
                    rows={4}
                    showCount
                />
            );

        case FieldType.NUMBER:
            return (
                <InputNumber
                    placeholder={`请输入${label}`}
                    disabled={disabled}
                    style={{ width: '100%' }}
                />
            );

        // case FieldType.MOBILE:
        //     return (
        //         <Input
        //             placeholder={`请输入${label}`}
        //             disabled={disabled}
        //             maxLength={11}
        //         />
        //     );

        // case FieldType.EMAIL:
        //     return (
        //         <Input
        //             placeholder={`请输入${label}`}
        //             disabled={disabled}
        //             type="email"
        //         />
        //     );

        case FieldType.DATE_SHORT:
            return (
                <DatePicker
                    placeholder={`请选择${label}`}
                    disabled={disabled}
                    // format="YYYY.MM.DD"
                    style={{ width: '100%' }}
                />
            );

        case FieldType.DATE_LONG:
            return (
                <DatePicker
                    placeholder={`请选择${label}`}
                    disabled={disabled}
                    format="YYYY年MM月DD日"
                    // format='YYYY-MM-DD HH:mm:ss'
                    style={{ width: '100%' }}
                />
            );

        case FieldType.DROPDOWN:
            return (
                <Select
                    placeholder={`请选择${label}`}
                    disabled={disabled}
                    allowClear
                >
                    {options?.map((option) => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
            );

        case FieldType.SINGLE_CHECKBOX:
            return (
                <Radio.Group disabled={disabled}>
                    {options?.map((option) => (
                        <Radio key={option.value} value={option.value}>
                            {option.label}
                        </Radio>
                    ))}
                </Radio.Group>
            );

        case FieldType.CHECKBOX:
            return (
                <Checkbox.Group disabled={disabled}>
                    {options?.map((option) => (
                        <Checkbox key={option.value} value={option.value}>
                            {option.label}
                        </Checkbox>
                    ))}
                </Checkbox.Group>
            );

        case FieldType.IMAGE:
            return (
                //   <Upload
                //     disabled={disabled}
                //     listType="picture-card"
                //     accept="image/*"
                //     maxCount={1}
                //   >
                //     <div>
                //       <UploadOutlined />
                //       <div style={{ marginTop: 8 }}>上传图片</div>
                //     </div>
                //   </Upload>
                <Input placeholder={`请输入${label}`} disabled={disabled} />
            );

        // case FieldType.SYSTEM_COMPANY:
        //     return (
        //         <Input
        //             placeholder={`系统企业信息`}
        //             disabled={true}
        //             value="自动获取企业信息"
        //         />
        //     );

        // case FieldType.SYSTEM_PERSON:
        //     return (
        //         <Input
        //             placeholder={`系统人员信息`}
        //             disabled={true}
        //             value="自动获取人员信息"
        //         />
        //     );

        default:
            return (
                <Input
                    placeholder={`请输入${label}`}
                    disabled={disabled}
                />
            );
    }
};
